import './App.css';
import AppRoutes from './route.js';

function App() {
  return <AppRoutes/>
}
export default App;
